module.exports = __webpack_public_path__ + "img/pallet-box.5981f0a7.svg";